// tons dos cards de categoria (template 1) a partir da cor do tema do cliente

function rgb(cor) {
  const h = cor.replace('#', '');
  return [0, 2, 4].map(i => parseInt(h.substr(i, 2), 16));
}

function hex(valores) {
  return `#${valores
    .map(v =>
      Math.round(Math.max(0, Math.min(255, v)))
        .toString(16)
        .padStart(2, '0')
    )
    .join('')}`;
}

export function mix(corA, corB, peso) {
  const A = rgb(corA);
  const B = rgb(corB);
  return hex(A.map((v, i) => v + (B[i] - v) * peso));
}

export function luminancia(cor) {
  const c = rgb(cor).map(v => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}

export function contraste(corA, corB) {
  const x = luminancia(corA);
  const y = luminancia(corB);
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
}

// 4 tons: 3 mais escuros e 1 claro. Tema preto clareia em vez de escurecer.
export function tonsCategoria(primary) {
  if (luminancia(primary) < 0.02) {
    return [0.1, 0.24, 0.38, 0.86].map(t => mix(primary, '#ffffff', t));
  }
  return [
    mix(primary, '#000000', 0.12),
    mix(primary, '#000000', 0.34),
    mix(primary, '#000000', 0.54),
    mix(primary, '#ffffff', 0.8),
  ];
}

// texto branco só quando passa 4,5:1, senão escuro
export function corTextoSobre(fundo) {
  return contraste(fundo, '#ffffff') >= 4.5 ? '#ffffff' : '#1a1a1a';
}
